export default {
  errorLogs: []
}
